import { createContext } from 'react';

export const AppMode = {
  MILB: 'MiLB',
  MLB: 'MLB',
} as const;

export type AppMode = (typeof AppMode)[keyof typeof AppMode];

export interface AppModeContextValue {
  appMode: AppMode;
  setAppMode: (appMode: AppMode) => void;
}

export const DEFAULT_APP_MODE: AppMode = AppMode.MLB;

export const getAppModeStorageKey = (userId: string) => `sportybot:app-mode:${userId}`;

export const AppModeContext = createContext<AppModeContextValue | null>(null);
